import { render, staticRenderFns } from "./indexEn.vue?vue&type=template&id=b0750b2a&scoped=true"
import script from "./indexEn.vue?vue&type=script&lang=js"
export * from "./indexEn.vue?vue&type=script&lang=js"
import style0 from "./indexEn.vue?vue&type=style&index=0&id=b0750b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0750b2a",
  null
  
)

export default component.exports